import React, { useState, useMemo } from "react";
import { IoIosSearch } from "react-icons/io";
import { FaArrowLeft } from "react-icons/fa";
import { IoMdPersonAdd } from "react-icons/io";

const MenuComponent = ({ onSelect, onClose, users = [],onAddUser,  sentIds = new Set()
}) => {
  const [searchText, setSearchText] = useState("");

  // Convert API structure → UI structure
  const formattedUsers = useMemo(() => {
    return users.map((user) => ({
      id: user.twgId,
      userAuthId: user.userAuthId,
      name: `${user.firstName || ""} ${user.lastName || ""}`.trim(),
      subtitle: user.email || "No Email",
      img: user.profilePicUrl || "",
      alreadySent: user.alreadySent || sentIds.has(user.userAuthId),
      receivedRequest:user.receivedRequest || false,
      sentRequestStatus:user.sentRequestStatus || "0"
    }));
  }, [users, sentIds]);
  

  // 🔍 Search by name OR email
  const filteredUsers = formattedUsers.filter((u) => {
    const text = searchText.toLowerCase();
    return (
      (u.name || "").toLowerCase().includes(text) ||
      (u.subtitle || "").toLowerCase().includes(text)
    );
  });

  return (
    <div className="bg-black text-white rounded-xl shadow-lg w-72 max-h-[500px] flex flex-col px-2 py-4">

      {/* Header */}
      <div className="flex items-center pb-3 ">
        <FaArrowLeft
          className="text-white w-5 h-5 mr-2 cursor-pointer"
          onClick={onClose}
        />
        <div className="flex items-center bg-neutral-800 rounded-lg px-3 py-2 flex-1">
          <IoIosSearch className="text-yellow-500 w-5 h-5 mr-2" />
          <input
            type="text"
            placeholder="Search name or email..."
            className="bg-transparent outline-none text-sm flex-1 placeholder-gray-400"
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
          />
        </div>
      </div>

      {/* Users List */}
      <div className="flex flex-col mt-2 space-y-4 flex-1 overflow-y-auto">
        {filteredUsers.map((person) => (
          <div
            key={person.id}
            className="flex items-center gap-3 cursor-pointer hover:bg-neutral-800 p-2 rounded-lg"
            onClick={() => onSelect(person)}
          >
            <div className="w-12 h-12 rounded-full border-2 border-yellow-500 p-[2px] overflow-hidden flex items-center justify-center bg-neutral-800">
              {person.img ? (
                <img
                  src={person.img}
                  alt={person.name}
                  className="w-full h-full rounded-full object-cover object-center"
                />
              ) : (
                <IoMdPersonAdd className="text-yellow-500 w-6 h-6" />
              )}
            </div>

            <div className="flex w-[80%] justify-between items-center">
              <div className="font-semibold text-[12px]">{person.name}</div>

              {person.sentRequestStatus === "1" ? (
  <p className="text-xs text-green-400">Already Friend</p>
) : person.receivedRequest ? (
  <p className="text-xs text-gray-400">Received</p>
) : person.alreadySent ? (
  <p className="text-xs text-gray-400">Sent</p>
) : (
  <IoMdPersonAdd
    className="text-[#F8BA34] text-lg cursor-pointer"
    onClick={(e) => {
      e.stopPropagation();

      onAddUser({
        userAuthId: person.userAuthId,
        circlerequeststatus: "0",
        rejectionnotes: "",
      });
    }}
  />
)}



            </div>
          </div>
        ))}

        {/* No results found */}
        {filteredUsers.length === 0 && (
          <p className="text-center text-gray-400 text-sm py-4">No users found</p>
        )}
      </div>

      <button className="bg-[#F8BA34] text-black rounded-[10px] py-2 font-semibold">
        Done
      </button>
    </div>
  );
};

export default MenuComponent;
